import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset;
          setIsVisible(scrollTop > 500);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 15 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 15 }}
          transition={{ duration: 0.4, ease: [0.23, 1, 0.32, 1] }}
          className="fixed bottom-8 right-6 z-40"
        >
          <motion.button
            onClick={scrollToTop}
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.95 }}
            animate={{ y: [0, -4, 0] }}
            transition={{ 
              y: { duration: 3, repeat: Infinity, ease: 'easeInOut' },
              scale: { duration: 0.2 },
            }}
            className="w-12 h-12 rounded-full flex items-center justify-center relative overflow-hidden group"
            aria-label="Back to top"
            style={{
              background: 'rgba(0, 0, 0, 0.02)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05), inset 0 0 12px rgba(0,0,0,0.02)',
            }}
          >
            {/* Glass highlight & hover effect */}
            <div 
              className="absolute inset-0 rounded-full transition-opacity duration-300 opacity-50 group-hover:opacity-100"
              style={{
                background: 'linear-gradient(135deg, rgba(0,0,0,0.04) 0%, transparent 50%)',
              }}
            />
            
            <ArrowUp 
              size={18} 
              className="relative z-10 transition-colors duration-300 text-[#475569] group-hover:text-[#0f172a]" 
            />
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;